import { IQuoteItem, IQuoteItemStatus, IQuoteResponsibleUser, IQuoteSummary } from './quote.types';

export interface IDeviceSuggestedItem extends IQuoteItemDetails {
  id: number;
  sku?: string;
  quoteStatus?: IQuoteItemStatus;
  productName?: string;
  productId?: number | null;
  categoryId?: number | null;
}

export interface IQuoteItemDetails {
  customerReason?: string;
  procurementReason?: string;
  providerName: string;
  quantity: number;
  providerUnitPrice: string;
  totalPrice: string;
  /** Moneda local del costo del proveedor. */
  currency?: string;
  /** Moneda del precio de venta (totalPrice). */
  saleCurrency?: string;
  exchangeRate?: number;
  etaMin: string;
  etaMax: string;
  etaPeriod: 'days' | 'weeks' | null;
  isGenericProduct?: boolean;
}

export interface IOrderTrackingDevice {
  id: number;
  productName: string;
  sku: string;
  units: number;
  productId?: number;
  categoryId?: number;
  totalAmount?: number;
}

export interface IQuotePurchaseOrder {
  id: number;
  orderGenerated?: string;
  createdAt?: string;
  expiresAt?: string;
  numberOfTools: number;
  items: IOrderTrackingDevice[];
}

export interface IQuotePurchaseTrackingOrder {
  orderGenerated?: number;
  total?: number;
  totalAmount?: number;
  createdAt: string;
  expiresAt: string;
  numberOfTools: number;
  isPaid: boolean;
  items: IOrderTrackingDevice[];
}

export interface IQuoteCounterInfo {
  total: number;
  approved: number;
  showCounter: boolean;
}

export interface IResponsible {
  id: number;
  name: string;
  urlImage: string;
}

export enum QUOTE_STATUS_CODE {
  PENDING = 'PENDING',
  TO_QUOTE = 'TO_QUOTE',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  APPROVED = 'APPROVED',
  PARTIAL_APPROVED = 'PARTIAL_APPROVED',
  REJECTED = 'REJECTED',
  EXPIRED = 'EXPIRED',
  PURCHASED = 'PURCHASED',
  CANCELLED = 'CANCELLED'
}

export interface IQuoteStatus {
  id: string;
  code: QUOTE_STATUS_CODE;
}

export interface IQuoteDetails {
  history: IQuoteHistory;
  lastUpdateDate: string;
  counterInfo: IQuoteCounterInfo;
  items: IQuoteItem[];
  responsibleUsers?: IQuoteResponsibleUser[];
  purchaseTracking: IQuotePurchaseOrder[];
  summary?: IQuoteSummary;
}

export interface IHistoryItem {
  type: string;
  date: string;
  description: string;
}

export interface IHistoryGroup {
  statusId: QUOTE_STATUS_CODE;
  label: string;
  items: IHistoryItem[];
}

export interface IQuoteHistory {
  cancelled: IHistoryItem[];
  expired: IHistoryItem[];
  approved: IHistoryItem[];
  pendingApproval: IHistoryItem[];
  toQuote: IHistoryItem[];
}

export enum bannerVariant {
  information = 'information',
  warning = 'warning',
  danger = 'danger'
}

export enum TABS {
  APPROVAL = '1',
  PURCHASE_TRACKING = '2'
}
